// Import models.
import ThirdPartyPropertyData from "./ThirdPartyPropertyData";
export default class ThirdPartyPropertyDataPersonal extends ThirdPartyPropertyData {

	public occupancyType: string | null = null;
	public yearRoofLastUpdated: number | null = null;
	public isBelowGradeOrEnclosedAreaFinished: boolean | null = null;
	public IsGarageAttached: boolean | null = null;

	public constructor() {
		super();
	}
}